
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/crazysalesoftheday",
      function () {
        return require("private-next-pages/crazysalesoftheday.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/crazysalesoftheday"])
      });
    }
  